import React, { FC, memo, useState } from "react"
import logo from "../../../Icons/logo.svg"
import { Input } from "../../../Input"
import { Button } from "../../../Button"
import girl from "./images/girl.webp"
import {
  LogoImgStyled,
  LogoStyled,
  RootStyled,
  WrapContentStyled,
  WrapContentLeftStyled,
  WrapContentRightStyled,
  GirlStyled,
  TitleStyled,
  SubtitleStyled,
  ContentLeftStyled,
  WrapEmail,
  WrapButton,
} from "./styles"

export const WeWillBeBackSoon: FC = memo(() => {
  const [email, setEmail] = useState("")

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
  }

  const validateEmail = (value: string) => {
    return String(value)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  }

  // See WantToBeInformed: submission waits on a receiver to send to.
  return (
    <RootStyled id="home">
      <LogoStyled href="/" target="_self">
        <LogoImgStyled height="37" alt="NeuraLoom" src={logo} />
      </LogoStyled>
      <WrapContentStyled>
        <WrapContentLeftStyled>
          <ContentLeftStyled>
            <TitleStyled>
              A SYNTHETIC MEDIA PLATFORM FOR THE NEXT FRONTIER
            </TitleStyled>
            <SubtitleStyled>
              AI-powered solution for Enterprise companies to generate Digital
              Employees and videos with neural networks
            </SubtitleStyled>
            <WrapEmail>
              <Input
                label="Enter your email:"
                inputProps={{
                  type: "email",
                  name: "EMAIL",
                  required: true,
                  placeholder: "your@email.com",
                  onChange,
                  value: email,
                }}
              />
              <WrapButton>
                <Button label="BE INFORMED" disabled={!validateEmail(email)} />
              </WrapButton>
            </WrapEmail>
          </ContentLeftStyled>
        </WrapContentLeftStyled>
        <WrapContentRightStyled>
          <GirlStyled src={girl} alt="" />
        </WrapContentRightStyled>
      </WrapContentStyled>
    </RootStyled>
  )
})
